import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Content`}</strong>{` is often organized in systems like databases, content management systems, files, or external APIs.`}</p>
    <p>{`Any source of data can be connected to Gatsby through plugins or using Gatsby’s APIs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      